<!-- inspection-detail.component.html -->
<div class="page-container" *ngIf="!loading; else loadingTpl">

    <!-- Header -->
    <div class="header-section">
        <div class="title-block">
            <h1>{{ isNew ? 'New Inspection Type' : 'Inspection Type Details' }}</h1>
        </div>

        <div class="header-actions">
            <button class="btn-secondary" (click)="goBack()">
                <span class="material-icons">arrow_back</span>
                Back
            </button>

            <button class="btn-primary" (click)="save()" [disabled]="saving || !formValid">
                <span class="material-icons">save</span>
                {{ saving ? 'Saving...' : 'Save' }}
            </button>
        </div>
    </div>

    <!-- Form Card -->
    <div class="card">

        <!-- Basic -->
        <div class="section">
            <div class="section-title">
                <span class="material-icons">description</span>
                Basic Information
            </div>

            <div class="form-grid">

                <!-- Customer -->
                <div class="form-field">
                    <label>Customer</label>

                    <!-- Customer selectable only when NEW -->
                    <p-select [filter]="true" *ngIf="isNew" [options]="customers" optionLabel="title"
                        [(ngModel)]="model.customer" placeholder="Please Select Customer..."
                        (ngModelChange)="onCustomerChange($event)">
                    </p-select>

                    <!-- Readonly customer when existing -->
                    <div class="readonly-box" *ngIf="!isNew">
                        {{ model.customer?.title }}
                    </div>

                    <div class="hint" *ngIf="!isNew">
                        Customer can't be changed after save.
                    </div>
                </div>

                <!-- Title -->
                <div class="form-field">
                    <label>Title</label>
                    <input class="text-input" [(ngModel)]="model.title" placeholder="Enter title..."
                        (ngModelChange)="recomputeFormValid()" />
                </div>

                <!-- Percent Packed -->
                <div class="form-field">
                    <label>Percent Packed</label>
                    <input class="text-input" type="number" min="0" max="100" [(ngModel)]="model.percentPacked"
                        (ngModelChange)="recomputeFormValid()" placeholder="0-100" />
                </div>

            </div>
        </div>

        <!-- Steps -->
        <div class="section">
            <div class="section-title">
                <span class="material-icons">checklist</span>
                Inspection Steps
            </div>

            <div class="toggle-grid">

                <label class="toggle-item">
                    <input type="checkbox" [(ngModel)]="model.isRequirements" />
                    <span>Requirements</span>
                </label>

                <label class="toggle-item">
                    <input type="checkbox" [(ngModel)]="model.isFactoryAudit" />
                    <span>Factory Audit</span>
                </label>

                <label class="toggle-item">
                    <input type="checkbox" [(ngModel)]="model.isProductStatus" />
                    <span>Product Status</span>
                </label>

                <label class="toggle-item">
                    <input type="checkbox" [(ngModel)]="model.isDefect" />
                    <span>Defect</span>
                </label>

                <label class="toggle-item">
                    <input type="checkbox" [(ngModel)]="model.isProductDetails" />
                    <span>Product Details</span>
                </label>

                <label class="toggle-item">
                    <input type="checkbox" [(ngModel)]="model.isMeasurements" />
                    <span>Measurements</span>
                </label>

                <label class="toggle-item">
                    <input type="checkbox" [(ngModel)]="model.isDocuments" />
                    <span>Documents</span>
                </label>

                <label class="toggle-item">
                    <input type="checkbox" [(ngModel)]="model.isIdenticalDesign" />
                    <span>Identical Design</span>
                </label>

                <label class="toggle-item">
                    <input type="checkbox" [(ngModel)]="model.isPacking" />
                    <span>Packing</span>
                </label>

            </div>
        </div>

    </div>

</div>

<ng-template #loadingTpl>
    <div class="loading-container">
        <p-progressSpinner styleClass="labtech-spinner" ariaLabel="Loading"></p-progressSpinner>
        <p>Loading inspection type...</p>
    </div>
</ng-template>
